
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog } from 'vant';
import leaveList from './component/leaveList.vue';

class Leave {
  IsDropOut?: boolean | undefined = false;
  className?: string | undefined = '';
  startDate?: string | undefined;
  endDate?: string | undefined;
  pageIndex: number | undefined = 1;
  pageSize: number | undefined = 20;
}

@Component({ components: { leaveList } })
export default class MyLeave extends Vue {
  showRevokeDialog: boolean = false;
  finished: boolean = false;
  loading: boolean = false;
  leaveForm: Leave = new Leave();
  leaveList: any = [];
  revokeId: string = '';

  get CommonAuditStatus() {
    return models.CommonAuditStatus;
  }

  get StateTag() {
    let color = null;
    let text = null;
    return (state: any) => {
      if (
        state.orgAuditStatus == this.CommonAuditStatus.待审核 ||
        (state.orgAuditStatus === null && state.auditStatus == this.CommonAuditStatus.待审核)
      ) {
        color = '#ff976a';
        text = '待审核';
      }
      if (
        (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == null) ||
        state.auditStatus == this.CommonAuditStatus.已通过
      ) {
        color = '#07c160';
        text = '已通过';
      }

      if (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == this.CommonAuditStatus.待审核) {
        color = '#1989fa';
        text = '干教处待审核';
      }
      if (
        state.orgAuditStatus == this.CommonAuditStatus.未通过 ||
        (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == this.CommonAuditStatus.未通过) ||
        (state.orgAuditStatus == null && state.auditStatus == this.CommonAuditStatus.未通过)
      ) {
        color = '#ff0000';
        text = '未通过';
      }
      return { color, text };
    };
  }

  // mounted() {
  //   this.getMyLeaves();
  // }

  toDetails(item: any) {
    this.$router.push({ name: 'leave', query: { leaveInfo: JSON.stringify(item), type: '请假详情' } });
  }

  async getMyLeaves() {
    this.loading = true;
    try {
      const { data } = await api.Leaves.findMyLeaves_GET(this.leaveForm);
      this.leaveForm.pageIndex++;
      const list = data.value.items;
      this.leaveList = this.leaveList.concat(list);
      if (this.leaveList.length == data.value.totalItemCount || data.value.items?.length == 0) this.finished = true;
    } catch (error) {
      Dialog.alert(error.message);
    } finally {
      this.loading = false;
    }
  }

  revoke(data) {
    this.showRevokeDialog = true;
    this.revokeId = data.id;
  }

  async revokeAsync() {
    try {
      const { data, success, message } = await api.Leaves.mobileCancel_POST({ id: this.revokeId });
      if (success) {
        this.showRevokeDialog = false;
        this.$dialog.alert({
          message: '撤销成功',
        });
        this.leaveForm.pageIndex = 1;
        this.finished = false;
        this.leaveList = [];
        this.getMyLeaves();
      } else {
        this.showRevokeDialog = false;
        this.$dialog.alert({
          message: message,
        });
      }
    } catch (error) {
      Dialog.alert({ message: error });
    }
  }
}
